import './Alert.scss';

type Severity = 'error' | 'warning' | 'info';

type Props = {
  severity: Severity;
  children: any;
};

function Alert(props: Props) {
  const { severity, children } = props;
  return (
    <div className={`configurator__alert ${severity} p-3 mt-3`} role="alert">
      {children}
    </div>
  );
}

export default Alert;
